import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PartnerOrgMessageService {

  @Output() applyFilterEvent = new EventEmitter();

  applyFilter(): void {
    this.applyFilterEvent.emit();
  }
}